import React, { useState } from "react";
import { Flex, Text, Textarea } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import usePostOrderHistoryConfirmedAmendOrder from "@/features/my-order/features/order-history/features/final-copy/hooks/query/usePostOrderHistoryConfirmedAmendOrder";
import { useSearchParams } from "react-router-dom";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

function OrderHistoryFinalCopyRevisionModal({ isOpen, onClose }: Props) {
  const { orderSheetSetId } = useOrderHistoryDetail();
  const [revisionMemo, setRevisionMemo] = useState("");
  const { postAmendOrder, isPending } = usePostOrderHistoryConfirmedAmendOrder(
    orderSheetSetId ? +orderSheetSetId : 0
  );

  const handleRevisionRequest = async () => {
    if (!orderSheetSetId) return;
    postAmendOrder({
      order_sheet_set_id: +orderSheetSetId,
      reason: revisionMemo,
    });
    handleClose();
  };

  const handleClose = () => {
    setRevisionMemo("");
    onClose();
  };

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={handleClose}>
      <CustomApprovalModal.Header
        title="수정 요청을 진행하시겠습니까?"
        onClose={handleClose}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"16px"}>
          <Text textStyle={"body-sm-regular"} color={"#6F6F6C"}>
            공급사가 확인할 수 있도록 수정이 필요한 사항을 입력해 주세요.
            <br />
            구체적으로 적어주시면 더 빠른 처리가 가능합니다.
          </Text>
          <Textarea
            placeholder="요청 사유를 입력해 주세요."
            value={revisionMemo}
            onChange={(e) => setRevisionMemo(e.target.value)}
            minHeight={"120px"}
            fontSize={"13px"}
            borderRadius={"4px"}
            boxShadow={"0 0 0 0.5px #8F8F8C"}
            padding={"8px 12px"}
            _placeholder={{ color: "#6F6F6C" }}
          />
        </Flex>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        onCancel={handleClose}
        onConfirm={handleRevisionRequest}
        confirmName="요청"
        isLoading={isPending}
        isConfirmDisabled={!revisionMemo.trim()}
      />
    </CustomApprovalModal>
  );
}

export default OrderHistoryFinalCopyRevisionModal;
